import { AddUserPopWrap } from './style';
import React, { ReactNode, useEffect, useRef, useState } from 'react'
import { Form, Input } from 'antd';
import { IMobileRef, IPOAccount, IPOMessage, IPOModal, IPOTag, IPOUtils, MobileInput } from '../../..';

interface IAddMemberProp {
	isShowAdd: boolean,
	majorTags: IPOTag.ITag[];
	teamTags: IPOTag.ITag[];
	handleAddAccount: (info: IPOAccount.IAddAccount) => Promise<string>;
	handleAddTag: (tagId: string, accountId: string) => Promise<void>;
	handleAddMember: (accountId: string) => Promise<void>;
	handleChange: () => void;
	uploadEle: ReactNode;
}

export const AddMember = ({ isShowAdd,
	majorTags, teamTags, handleAddAccount, handleAddTag, handleChange, uploadEle, handleAddMember }: IAddMemberProp) => {
	const [addForm] = Form.useForm();
	const mobileRef = useRef<IMobileRef>();

	const [teamSelect, setTeamSelect] = useState<string[]>([]);
	const [majorSelect, setMajorSelect] = useState<string[]>([]);

	useEffect(() => {
		if (!isShowAdd) {
			addForm.resetFields()
			uploadEle = null
		}
	}, [isShowAdd])

	const handleOk = () => {

		const mobileValidate = mobileRef.current?.getValidateRes()

		if (mobileValidate) {
			const addParams = {
				name: addForm.getFieldValue('name') ?? '',
				name2: addForm.getFieldValue('name2') ?? '',
				email: addForm.getFieldValue('email') ?? '',
				avatar: addForm.getFieldValue('avatar') ?? '',
				areaCode: mobileValidate.mobileInfo.areaCode,
				mobile: mobileValidate.mobileInfo.phoneNum,
			}

			IPOUtils.regMember({ ...addParams, ...{ teams: teamSelect, ability: majorSelect } })
				.then(() => {
					handleAddAccount(addParams).then((res) => {
						handleAddMember(res).then(() => {
							IPOMessage.success('添加成功');
							let tags: string[] = []
							tags.push(...teamSelect)
							tags.push(...majorSelect)
							tags.forEach((tag: string) => {
								handleAddTag(tag, res)
							})
						})
					})
				})
				.then(() => {
					handleChange()
				})
		}
	};

	return (
		<AddUserPopWrap>
			<IPOModal
				title='添加成员'
				isShowPadding
				visible={isShowAdd}
				okText='确定'
				cancelText='取消'
				onOk={handleOk}
				onCancel={() => handleChange()}
				getContainer={false}
				maskClosable={false}
			>
				<Form
					form={addForm}
					name="basic"
					labelCol={{ span: 4 }}
					wrapperCol={{ span: 20 }}
					initialValues={{ remember: true }}
					autoComplete="off">
					<Form.Item label="头像" name="avatar">
						{uploadEle}
					</Form.Item>
					<Form.Item label="英文名" name="name">
						<Input />
					</Form.Item>
					<Form.Item label="中文名" name="name2">
						<Input />
					</Form.Item>
					<Form.Item label="手机号" name="mobile" required>
						<MobileInput
							mobileRef={mobileRef}
						/>
					</Form.Item>
					<Form.Item label="邮箱" name="email">
						<Input />
					</Form.Item>
					<Form.Item label="专业" name="major" required>
						<IPOTag.SelectTag
							dataList={majorTags}
							onChange={(list) => setMajorSelect((list as unknown) as string[])}></IPOTag.SelectTag>
					</Form.Item>
					<Form.Item label="团队" name="team" required>
						<IPOTag.SelectTag
							dataList={teamTags}
							onChange={(list) => setTeamSelect((list as unknown) as string[])}></IPOTag.SelectTag>
					</Form.Item>
				</Form>
			</IPOModal>
		</AddUserPopWrap>
	)
}